// extracted by mini-css-extract-plugin
module.exports =  {"main-title-actions-group":"CellTitleActions-module__main-title-actions-group___rYSwk","cell-title-actions":"CellTitleActions-module__cell-title-actions___gVGiv"};